'use strict';

var currencies = {
  AED: {
    symbol: '.د.إ',
    after: true,
    precision: 2
  },
  AFN: {
    symbol: '؋',
    after: true,
    precision: 2
  },
  ALL: {
    symbol: 'L',
    after: false,
    precision: 2
  },
  AMD: {
    symbol: 'դր.',
    after: true,
    precision: 2
  },
  ANG: {
    symbol: 'ƒ',
    after: false,
    precision: 2
  },
  AOA: {
    symbol: 'AOA',
    after: true,
    precision: 2
  },
  ARS: {
    symbol: '$',
    after: false,
    precision: 2
  },
  AUD: {
    symbol: '$',
    after: false,
    precision: 2
  },
  AWG: {
    symbol: 'ƒ',
    after: false,
    precision: 2
  },
  AZN: {
    symbol: '₼',
    after: false,
    precision: 2
  },
  BAM: {
    symbol: 'KM',
    after: false,
    precision: 2
  },
  BBD: {
    symbol: '$',
    after: false,
    precision: 2
  },
  BDT: {
    symbol: 'BDT',
    after: true,
    precision: 2
  },
  BGN: {
    symbol: 'лв',
    after: false,
    precision: 2
  },
  BHD: {
    symbol: '.د.ب',
    after: true,
    precision: 3
  },
  BIF: {
    symbol: 'BIF',
    after: true,
    precision: 0
  },
  BMD: {
    symbol: '$',
    after: false,
    precision: 2
  },
  BND: {
    symbol: '$',
    after: false,
    precision: 2
  },
  BOB: {
    symbol: 'Bs.',
    after: false,
    precision: 2
  },
  BRL: {
    symbol: 'R$',
    after: false,
    precision: 2
  },
  BSD: {
    symbol: '$',
    after: false,
    precision: 2
  },
  BTN: {
    symbol: 'BTN',
    after: true,
    precision: 2
  },
  BWP: {
    symbol: 'P',
    after: false,
    precision: 2
  },
  BYN: {
    symbol: 'p.',
    after: true,
    precision: 2
  },
  BZD: {
    symbol: 'BZ$',
    after: false,
    precision: 2
  },
  CAD: {
    symbol: '$',
    after: false,
    precision: 2
  },
  CDF: {
    symbol: 'CDF',
    after: true,
    precision: 2
  },
  CHF: {
    symbol: 'CHF ',
    after: false,
    precision: 2
  },
  CLP: {
    symbol: '$',
    after: false,
    precision: 0
  },
  CNY: {
    symbol: '元',
    after: true,
    precision: 2
  },
  COP: {
    symbol: '$',
    after: false,
    precision: 0
  },
  CRC: {
    symbol: '₡',
    after: false,
    precision: 2
  },
  CUC: {
    symbol: 'CUC',
    after: true,
    precision: 2
  },
  CUP: {
    symbol: '$',
    after: false,
    precision: 2
  },
  CVE: {
    symbol: 'CVE',
    after: true,
    precision: 2
  },
  CZK: {
    symbol: 'Kč',
    after: true,
    precision: 2
  },
  DJF: {
    symbol: 'DJF',
    after: true,
    precision: 0
  },
  DKK: {
    symbol: 'kr',
    after: true,
    precision: 2
  },
  DOP: {
    symbol: 'RD$',
    after: false,
    precision: 2
  },
  DZD: {
    symbol: '.د.ج',
    after: true,
    precision: 2
  },
  EGP: {
    symbol: '£',
    after: false,
    precision: 2
  },
  ERN: {
    symbol: 'ERN',
    after: true,
    precision: 2
  },
  ETB: {
    symbol: 'ETB',
    after: true,
    precision: 2
  },
  EUR: {
    symbol: '€',
    after: true,
    precision: 2
  },
  FJD: {
    symbol: '$',
    after: false,
    precision: 2
  },
  FKP: {
    symbol: '£',
    after: false,
    precision: 2
  },
  GBP: {
    symbol: '£',
    after: false,
    precision: 2
  },
  GEL: {
    symbol: '₾',
    after: false,
    precision: 2
  },
  GGP: {
    symbol: '£',
    after: false,
    precision: 2
  },
  GHS: {
    symbol: 'GHS',
    after: true,
    precision: 2
  },
  GIP: {
    symbol: '£',
    after: false,
    precision: 2
  },
  GMD: {
    symbol: 'GMD',
    after: true,
    precision: 2
  },
  GNF: {
    symbol: 'GNF',
    after: true,
    precision: 0
  },
  GTQ: {
    symbol: 'Q',
    after: false,
    precision: 2
  },
  GYD: {
    symbol: '$',
    after: false,
    precision: 2
  },
  HKD: {
    symbol: 'HKD ',
    after: false,
    precision: 2
  },
  HNL: {
    symbol: 'L',
    after: false,
    precision: 2
  },
  HRK: {
    symbol: 'kn',
    after: false,
    precision: 2
  },
  HTG: {
    symbol: 'G',
    after: false,
    precision: 2
  },
  HUF: {
    symbol: ' Ft',
    after: true,
    precision: 0
  },
  IDR: {
    symbol: 'Rp',
    after: false,
    precision: 2
  },
  ILS: {
    symbol: '₪',
    after: false,
    precision: 2
  },
  IMP: {
    symbol: '£',
    after: false,
    precision: 2
  },
  INR: {
    symbol: '₹',
    after: false,
    precision: 2
  },
  IQD: {
    symbol: '.د.ع',
    after: true,
    precision: 3
  },
  IRR: {
    symbol: '﷼',
    after: true,
    precision: 0
  },
  IRT: {
    // https://en.wikipedia.org/wiki/Iranian_toman
    symbol: 'تومان',
    after: true,
    precision: 0
  },
  ISK: {
    symbol: 'kr',
    after: false,
    precision: 2
  },
  JEP: {
    symbol: '£',
    after: false,
    precision: 2
  },
  JMD: {
    symbol: 'J$',
    after: false,
    precision: 2
  },
  JOD: {
    symbol: '.د.إ',
    after: true,
    precision: 3
  },
  JPY: {
    // this is for Japan, ¥ is the international jpy symbol
    symbol: '円',
    after: false,
    precision: 2
  },
  KES: {
    symbol: 'KSh',
    after: false,
    precision: 2
  },
  KGS: {
    symbol: 'сом',
    after: false,
    precision: 2
  },
  KHR: {
    symbol: '៛',
    after: false,
    precision: 2
  },
  KMF: {
    symbol: 'KMF',
    after: true,
    precision: 0
  },
  KPW: {
    symbol: '₩',
    after: false,
    precision: 0
  },
  KRW: {
    symbol: '₩',
    after: false,
    precision: 0
  },
  KWD: {
    symbol: ' د.ك',
    after: true,
    precision: 2
  },
  KWD_EN: {
    symbol: 'KD',
    after: true,
    precision: 2
  },
  KYD: {
    symbol: '$',
    after: false,
    precision: 2
  },
  KZT: {
    symbol: '₸',
    after: false,
    precision: 2
  },
  LAK: {
    symbol: '₭',
    after: false,
    precision: 2
  },
  LBP: {
    symbol: '£',
    after: false,
    precision: 2
  },
  LKR: {
    symbol: '₨',
    after: false,
    precision: 2
  },
  LRD: {
    symbol: '$',
    after: false,
    precision: 2
  },
  LSL: {
    symbol: 'LSL',
    after: true,
    precision: 2
  },
  LYD: {
    symbol: '.د.ل',
    after: true,
    precision: 3
  },
  MAD: {
    symbol: '.د.م',
    after: true,
    precision: 2
  },
  MDL: {
    symbol: 'MDL',
    after: true,
    precision: 2
  },
  MGA: {
    symbol: 'MGA',
    after: true,
    precision: 2
  },
  MKD: {
    symbol: 'ден',
    after: false,
    precision: 2
  },
  MMK: {
    symbol: 'MMK',
    after: true,
    precision: 2
  },
  MNT: {
    symbol: '₮',
    after: false,
    precision: 2
  },
  MOP: {
    symbol: 'MOP',
    after: true,
    precision: 2
  },
  MRO: {
    symbol: 'MRO',
    after: true,
    precision: 2
  },
  MUR: {
    symbol: '₨',
    after: false,
    precision: 2
  },
  MVR: {
    symbol: 'MVR',
    after: true,
    precision: 2
  },
  MWK: {
    symbol: 'MWK',
    after: true,
    precision: 2
  },
  MXN: {
    symbol: '$',
    after: false,
    precision: 2
  },
  MYR: {
    symbol: 'RM',
    after: false,
    precision: 2
  },
  MZN: {
    symbol: 'MT',
    after: false,
    precision: 2
  },
  NAD: {
    symbol: '$',
    after: false,
    precision: 2
  },
  NGN: {
    symbol: '₦',
    after: false,
    precision: 2
  },
  NIO: {
    symbol: 'C$',
    after: false,
    precision: 2
  },
  NOK: {
    symbol: 'kr',
    after: true,
    precision: 2
  },
  NPR: {
    symbol: '₨',
    after: false,
    precision: 2
  },
  NZD: {
    symbol: '$',
    after: false,
    precision: 2
  },
  EN_NZ: {
    symbol: '$',
    after: false,
    precision: 2
  },
  OMR: {
    symbol: '﷼',
    after: true,
    precision: 3
  },
  PAB: {
    symbol: 'B/.',
    after: false,
    precision: 2
  },
  PEN: {
    symbol: 'S/',
    after: false,
    precision: 2
  },
  PGK: {
    symbol: 'PGK',
    after: true,
    precision: 2
  },
  PHP: {
    symbol: '₱',
    after: false,
    precision: 2
  },
  PKR: {
    symbol: '₨',
    after: false,
    precision: 2
  },
  PLN: {
    symbol: ' zł',
    after: true,
    precision: 2
  },
  PYG: {
    symbol: '₲',
    after: true,
    precision: 0
  },
  QAR: {
    symbol: '﷼',
    after: true,
    precision: 2
  },
  RON: {
    symbol: 'RON',
    after: true,
    precision: 2
  },
  RSD: {
    symbol: 'Дин.',
    after: false,
    precision: 2
  },
  RUB: {
    symbol: ' руб.',
    after: true,
    precision: 0
  },
  RUP: {
    symbol: 'Rp ',
    after: false,
    precision: 0
  },
  RWF: {
    symbol: 'RWF',
    after: true,
    precision: 0
  },
  SAR: {
    symbol: '﷼',
    after: true,
    precision: 2
  },
  SBD: {
    symbol: '$',
    after: false,
    precision: 2
  },
  SCR: {
    symbol: '₨',
    after: false,
    precision: 2
  },
  SDG: {
    symbol: 'SDG',
    after: true,
    precision: 2
  },
  SEK: {
    symbol: ' kr',
    after: true,
    precision: 2
  },
  SGD: {
    symbol: 'S$ ',
    after: false,
    precision: 2
  },
  SHP: {
    symbol: '£',
    after: false,
    precision: 2
  },
  SLL: {
    symbol: 'SLL',
    after: true,
    precision: 2
  },
  SOS: {
    symbol: 'S',
    after: false,
    precision: 2
  },
  SRD: {
    symbol: '$',
    after: false,
    precision: 2
  },
  SSP: {
    symbol: 'SSP',
    after: true,
    precision: 2
  },
  STD: {
    symbol: 'STD',
    after: true,
    precision: 2
  },
  SYP: {
    symbol: '£',
    after: false,
    precision: 2
  },
  SZL: {
    symbol: 'SZL',
    after: true,
    precision: 2
  },
  THB: {
    symbol: '฿',
    after: false,
    precision: 2
  },
  TJS: {
    symbol: 'TJS',
    after: true,
    precision: 2
  },
  TMT: {
    symbol: 'TMT',
    after: true,
    precision: 2
  },
  TND: {
    symbol: '.د.ت',
    after: true,
    precision: 3
  },
  TOP: {
    symbol: 'TOP',
    after: true,
    precision: 2
  },
  TRY: {
    symbol: ' TL',
    after: true,
    precision: 2
  },
  TTD: {
    symbol: 'TT$',
    after: false,
    precision: 2
  },
  TWD: {
    symbol: 'NT$',
    after: false,
    precision: 0
  },
  TZS: {
    symbol: 'TSh',
    after: false,
    precision: 0
  },
  UAH: {
    symbol: '₴',
    after: false,
    precision: 2
  },
  UGX: {
    symbol: 'USh',
    after: false,
    precision: 0
  },
  USD: {
    symbol: '$',
    after: false,
    precision: 2
  },
  UYU: {
    symbol: '$U',
    after: false,
    precision: 0
  },
  UZS: {
    symbol: 'so’m',
    after: false,
    precision: 2
  },
  VEF: {
    symbol: 'Bs',
    after: false,
    precision: 2
  },
  VND: {
    symbol: '₫',
    after: true,
    precision: 0
  },
  VUV: {
    symbol: 'VUV',
    after: true,
    precision: 0
  },
  WST: {
    symbol: 'WST',
    after: true,
    precision: 2
  },
  XAF: {
    symbol: 'XAF',
    after: true,
    precision: 0
  },
  XCD: {
    symbol: '$',
    after: false,
    precision: 2
  },
  XOF: {
    symbol: 'XOF',
    after: true,
    precision: 0
  },
  XPF: {
    symbol: 'XPF',
    after: true,
    precision: 0
  },
  YER: {
    symbol: '﷼',
    after: true,
    precision: 2
  },
  ZAR: {
    symbol: 'R',
    after: false,
    precision: 2
  },
  ZMW: {
    symbol: 'ZMW',
    after: true,
    precision: 2
  }
};

module.exports = currencies;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9vcHQvZGF0YS9qZW5raW5zL2pvYnMvZGlzY292ZXJ5X2J1aWxkL3dvcmtzcGFjZS9kaXNjb3ZlcnkvZGlzY292ZXJ5L3NyYy9qcy9jdXJyZW5jeS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxZQUFZLENBQUM7O0FBRWIsSUFBSSxVQUFVLEdBQUc7QUFDZixLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsTUFBTTtBQUNkLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLElBQUk7QUFDWCxhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsR0FBRztBQUNYLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsR0FBRztBQUNYLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxJQUFJO0FBQ1osU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxJQUFJO0FBQ1osU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLE1BQU07QUFDZCxTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxJQUFJO0FBQ1osU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLElBQUk7QUFDWixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsTUFBTTtBQUNkLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsR0FBRztBQUNYLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsR0FBRztBQUNYLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxLQUFLO0FBQ2IsU0FBSyxFQUFFLElBQUk7QUFDWCxhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLElBQUk7QUFDWixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxJQUFJO0FBQ1osU0FBSyxFQUFFLElBQUk7QUFDWCxhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsTUFBTTtBQUNkLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLElBQUk7QUFDWCxhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsR0FBRztBQUNYLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsR0FBRztBQUNYLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxLQUFLO0FBQ2IsU0FBSyxFQUFFLElBQUk7QUFDWCxhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxLQUFLO0FBQ2IsU0FBSyxFQUFFLElBQUk7QUFDWCxhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsR0FBRztBQUNYLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxNQUFNO0FBQ2QsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsSUFBSTtBQUNaLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsSUFBSTtBQUNaLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsR0FBRztBQUNYLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxNQUFNO0FBQ2QsU0FBSyxFQUFFLElBQUk7QUFDWCxhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7O0FBRUgsVUFBTSxFQUFFLE9BQU87QUFDZixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsSUFBSTtBQUNaLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLElBQUk7QUFDWixTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsTUFBTTtBQUNkLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTs7QUFFSCxVQUFNLEVBQUUsR0FBRztBQUNYLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxLQUFLO0FBQ2IsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsR0FBRztBQUNYLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxLQUFLO0FBQ2IsU0FBSyxFQUFFLElBQUk7QUFDWCxhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsR0FBRztBQUNYLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxNQUFNO0FBQ2QsU0FBSyxFQUFFLElBQUk7QUFDWCxhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsUUFBTSxFQUFFO0FBQ04sVUFBTSxFQUFFLElBQUk7QUFDWixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsR0FBRztBQUNYLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsR0FBRztBQUNYLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxNQUFNO0FBQ2QsU0FBSyxFQUFFLElBQUk7QUFDWCxhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLE1BQU07QUFDZCxTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxLQUFLO0FBQ2IsU0FBSyxFQUFFLElBQUk7QUFDWCxhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLElBQUk7QUFDWixTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsSUFBSTtBQUNaLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsSUFBSTtBQUNaLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxJQUFJO0FBQ1osU0FBSyxFQUFFLElBQUk7QUFDWCxhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsR0FBRztBQUNYLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELE9BQUssRUFBRTtBQUNMLFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxJQUFJO0FBQ1osU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsR0FBRztBQUNYLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsR0FBRztBQUNYLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLElBQUk7QUFDWCxhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsTUFBTTtBQUNkLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxPQUFPO0FBQ2YsU0FBSyxFQUFFLElBQUk7QUFDWCxhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLElBQUk7QUFDWCxhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsR0FBRztBQUNYLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxLQUFLO0FBQ2IsU0FBSyxFQUFFLElBQUk7QUFDWCxhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsR0FBRztBQUNYLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsR0FBRztBQUNYLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxLQUFLO0FBQ2IsU0FBSyxFQUFFLElBQUk7QUFDWCxhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsTUFBTTtBQUNkLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxLQUFLO0FBQ2IsU0FBSyxFQUFFLElBQUk7QUFDWCxhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxLQUFLO0FBQ2IsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsR0FBRztBQUNYLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxLQUFLO0FBQ2IsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsSUFBSTtBQUNaLFNBQUssRUFBRSxLQUFLO0FBQ1osYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxNQUFNO0FBQ2QsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLElBQUk7QUFDWixTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsR0FBRztBQUNYLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxLQUFLO0FBQ2IsU0FBSyxFQUFFLElBQUk7QUFDWCxhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLEtBQUs7QUFDWixhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEtBQUs7QUFDYixTQUFLLEVBQUUsSUFBSTtBQUNYLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtBQUNELEtBQUcsRUFBRTtBQUNILFVBQU0sRUFBRSxHQUFHO0FBQ1gsU0FBSyxFQUFFLElBQUk7QUFDWCxhQUFTLEVBQUUsQ0FBQztHQUNiO0FBQ0QsS0FBRyxFQUFFO0FBQ0gsVUFBTSxFQUFFLEdBQUc7QUFDWCxTQUFLLEVBQUUsS0FBSztBQUNaLGFBQVMsRUFBRSxDQUFDO0dBQ2I7QUFDRCxLQUFHLEVBQUU7QUFDSCxVQUFNLEVBQUUsS0FBSztBQUNiLFNBQUssRUFBRSxJQUFJO0FBQ1gsYUFBUyxFQUFFLENBQUM7R0FDYjtDQUNGLENBQUM7O0FBRUYsTUFBTSxDQUFDLE9BQU8sR0FBRyxVQUFVLENBQUMiLCJmaWxlIjoiL29wdC9kYXRhL2plbmtpbnMvam9icy9kaXNjb3ZlcnlfYnVpbGQvd29ya3NwYWNlL2Rpc2NvdmVyeS9kaXNjb3Zlcnkvc3JjL2pzL2N1cnJlbmN5LmpzIiwic291cmNlc0NvbnRlbnQiOlsiJ3VzZSBzdHJpY3QnO1xuXG52YXIgY3VycmVuY2llcyA9IHtcbiAgQUVEOiB7XG4gICAgc3ltYm9sOiAnLtivLtilJyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEFGTjoge1xuICAgIHN5bWJvbDogJ9iLJyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEFMTDoge1xuICAgIHN5bWJvbDogJ0wnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEFNRDoge1xuICAgIHN5bWJvbDogJ9Wk1oAuJyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEFORzoge1xuICAgIHN5bWJvbDogJ8aSJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBBT0E6IHtcbiAgICBzeW1ib2w6ICdBT0EnLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgQVJTOiB7XG4gICAgc3ltYm9sOiAnJCcsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgQVVEOiB7XG4gICAgc3ltYm9sOiAnJCcsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgQVdHOiB7XG4gICAgc3ltYm9sOiAnxpInLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEFaTjoge1xuICAgIHN5bWJvbDogJ+KCvCcsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgQkFNOiB7XG4gICAgc3ltYm9sOiAnS00nLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEJCRDoge1xuICAgIHN5bWJvbDogJyQnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEJEVDoge1xuICAgIHN5bWJvbDogJ0JEVCcsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBCR046IHtcbiAgICBzeW1ib2w6ICfQu9CyJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBCSEQ6IHtcbiAgICBzeW1ib2w6ICcu2K8u2KgnLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMyxcbiAgfSxcbiAgQklGOiB7XG4gICAgc3ltYm9sOiAnQklGJyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDAsXG4gIH0sXG4gIEJNRDoge1xuICAgIHN5bWJvbDogJyQnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEJORDoge1xuICAgIHN5bWJvbDogJyQnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEJPQjoge1xuICAgIHN5bWJvbDogJ0JzLicsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgQlJMOiB7XG4gICAgc3ltYm9sOiAnUiQnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEJTRDoge1xuICAgIHN5bWJvbDogJyQnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEJUTjoge1xuICAgIHN5bWJvbDogJ0JUTicsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBCV1A6IHtcbiAgICBzeW1ib2w6ICdQJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBCWU46IHtcbiAgICBzeW1ib2w6ICdwLicsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBCWkQ6IHtcbiAgICBzeW1ib2w6ICdCWiQnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIENBRDoge1xuICAgIHN5bWJvbDogJyQnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIENERjoge1xuICAgIHN5bWJvbDogJ0NERicsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBDSEY6IHtcbiAgICBzeW1ib2w6ICdDSEYgJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBDTFA6IHtcbiAgICBzeW1ib2w6ICckJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAwLFxuICB9LFxuICBDTlk6IHtcbiAgICBzeW1ib2w6ICflhYMnLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgQ09QOiB7XG4gICAgc3ltYm9sOiAnJCcsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMCxcbiAgfSxcbiAgQ1JDOiB7XG4gICAgc3ltYm9sOiAn4oKhJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBDVUM6IHtcbiAgICBzeW1ib2w6ICdDVUMnLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgQ1VQOiB7XG4gICAgc3ltYm9sOiAnJCcsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgQ1ZFOiB7XG4gICAgc3ltYm9sOiAnQ1ZFJyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIENaSzoge1xuICAgIHN5bWJvbDogJ0vEjScsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBESkY6IHtcbiAgICBzeW1ib2w6ICdESkYnLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMCxcbiAgfSxcbiAgREtLOiB7XG4gICAgc3ltYm9sOiAna3InLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgRE9QOiB7XG4gICAgc3ltYm9sOiAnUkQkJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBEWkQ6IHtcbiAgICBzeW1ib2w6ICcu2K8u2KwnLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgRUdQOiB7XG4gICAgc3ltYm9sOiAnwqMnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEVSTjoge1xuICAgIHN5bWJvbDogJ0VSTicsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBFVEI6IHtcbiAgICBzeW1ib2w6ICdFVEInLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgRVVSOiB7XG4gICAgc3ltYm9sOiAn4oKsJyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEZKRDoge1xuICAgIHN5bWJvbDogJyQnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEZLUDoge1xuICAgIHN5bWJvbDogJ8KjJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBHQlA6IHtcbiAgICBzeW1ib2w6ICfCoycsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgR0VMOiB7XG4gICAgc3ltYm9sOiAn4oK+JyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBHR1A6IHtcbiAgICBzeW1ib2w6ICfCoycsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgR0hTOiB7XG4gICAgc3ltYm9sOiAnR0hTJyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEdJUDoge1xuICAgIHN5bWJvbDogJ8KjJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBHTUQ6IHtcbiAgICBzeW1ib2w6ICdHTUQnLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgR05GOiB7XG4gICAgc3ltYm9sOiAnR05GJyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDAsXG4gIH0sXG4gIEdUUToge1xuICAgIHN5bWJvbDogJ1EnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEdZRDoge1xuICAgIHN5bWJvbDogJyQnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEhLRDoge1xuICAgIHN5bWJvbDogJ0hLRCAnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEhOTDoge1xuICAgIHN5bWJvbDogJ0wnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEhSSzoge1xuICAgIHN5bWJvbDogJ2tuJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBIVEc6IHtcbiAgICBzeW1ib2w6ICdHJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBIVUY6IHtcbiAgICBzeW1ib2w6ICcgRnQnLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMCxcbiAgfSxcbiAgSURSOiB7XG4gICAgc3ltYm9sOiAnUnAnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIElMUzoge1xuICAgIHN5bWJvbDogJ+KCqicsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgSU1QOiB7XG4gICAgc3ltYm9sOiAnwqMnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIElOUjoge1xuICAgIHN5bWJvbDogJ+KCuScsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgSVFEOiB7XG4gICAgc3ltYm9sOiAnLtivLti5JyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDMsXG4gIH0sXG4gIElSUjoge1xuICAgIHN5bWJvbDogJ++3vCcsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAwLFxuICB9LFxuICBJUlQ6IHtcbiAgICAvLyBodHRwczovL2VuLndpa2lwZWRpYS5vcmcvd2lraS9JcmFuaWFuX3RvbWFuXG4gICAgc3ltYm9sOiAn2KrZiNmF2KfZhicsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAwLFxuICB9LFxuICBJU0s6IHtcbiAgICBzeW1ib2w6ICdrcicsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgSkVQOiB7XG4gICAgc3ltYm9sOiAnwqMnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEpNRDoge1xuICAgIHN5bWJvbDogJ0okJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBKT0Q6IHtcbiAgICBzeW1ib2w6ICcu2K8u2KUnLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMyxcbiAgfSxcbiAgSlBZOiB7XG4gICAgLy8gdGhpcyBpcyBmb3IgSmFwYW4sIMKlIGlzIHRoZSBpbnRlcm5hdGlvbmFsIGpweSBzeW1ib2xcbiAgICBzeW1ib2w6ICflhoYnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEtFUzoge1xuICAgIHN5bWJvbDogJ0tTaCcsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgS0dTOiB7XG4gICAgc3ltYm9sOiAn0YHQvtC8JyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBLSFI6IHtcbiAgICBzeW1ib2w6ICfhn5snLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEtNRjoge1xuICAgIHN5bWJvbDogJ0tNRicsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAwLFxuICB9LFxuICBLUFc6IHtcbiAgICBzeW1ib2w6ICfigqknLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDAsXG4gIH0sXG4gIEtSVzoge1xuICAgIHN5bWJvbDogJ+KCqScsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMCxcbiAgfSxcbiAgS1dEOiB7XG4gICAgc3ltYm9sOiAnINivLtmDJyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEtXRF9FTjoge1xuICAgIHN5bWJvbDogJ0tEJyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEtZRDoge1xuICAgIHN5bWJvbDogJyQnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEtaVDoge1xuICAgIHN5bWJvbDogJ+KCuCcsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgTEFLOiB7XG4gICAgc3ltYm9sOiAn4oKtJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBMQlA6IHtcbiAgICBzeW1ib2w6ICfCoycsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgTEtSOiB7XG4gICAgc3ltYm9sOiAn4oKoJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBMUkQ6IHtcbiAgICBzeW1ib2w6ICckJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBMU0w6IHtcbiAgICBzeW1ib2w6ICdMU0wnLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgTFlEOiB7XG4gICAgc3ltYm9sOiAnLtivLtmEJyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDMsXG4gIH0sXG4gIE1BRDoge1xuICAgIHN5bWJvbDogJy7Yry7ZhScsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBNREw6IHtcbiAgICBzeW1ib2w6ICdNREwnLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgTUdBOiB7XG4gICAgc3ltYm9sOiAnTUdBJyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIE1LRDoge1xuICAgIHN5bWJvbDogJ9C00LXQvScsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgTU1LOiB7XG4gICAgc3ltYm9sOiAnTU1LJyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIE1OVDoge1xuICAgIHN5bWJvbDogJ+KCricsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgTU9QOiB7XG4gICAgc3ltYm9sOiAnTU9QJyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIE1STzoge1xuICAgIHN5bWJvbDogJ01STycsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBNVVI6IHtcbiAgICBzeW1ib2w6ICfigqgnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIE1WUjoge1xuICAgIHN5bWJvbDogJ01WUicsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBNV0s6IHtcbiAgICBzeW1ib2w6ICdNV0snLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgTVhOOiB7XG4gICAgc3ltYm9sOiAnJCcsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgTVlSOiB7XG4gICAgc3ltYm9sOiAnUk0nLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIE1aTjoge1xuICAgIHN5bWJvbDogJ01UJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBOQUQ6IHtcbiAgICBzeW1ib2w6ICckJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBOR046IHtcbiAgICBzeW1ib2w6ICfigqYnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIE5JTzoge1xuICAgIHN5bWJvbDogJ0MkJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBOT0s6IHtcbiAgICBzeW1ib2w6ICdrcicsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBOUFI6IHtcbiAgICBzeW1ib2w6ICfigqgnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIE5aRDoge1xuICAgIHN5bWJvbDogJyQnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIEVOX05aOiB7XG4gICAgc3ltYm9sOiAnJCcsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgT01SOiB7XG4gICAgc3ltYm9sOiAn77e8JyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDMsXG4gIH0sXG4gIFBBQjoge1xuICAgIHN5bWJvbDogJ0IvLicsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgUEVOOiB7XG4gICAgc3ltYm9sOiAnUy8nLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIFBHSzoge1xuICAgIHN5bWJvbDogJ1BHSycsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBQSFA6IHtcbiAgICBzeW1ib2w6ICfigrEnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIFBLUjoge1xuICAgIHN5bWJvbDogJ+KCqCcsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgUExOOiB7XG4gICAgc3ltYm9sOiAnIHrFgicsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBQWUc6IHtcbiAgICBzeW1ib2w6ICfigrInLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMCxcbiAgfSxcbiAgUUFSOiB7XG4gICAgc3ltYm9sOiAn77e8JyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIFJPTjoge1xuICAgIHN5bWJvbDogJ1JPTicsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBSU0Q6IHtcbiAgICBzeW1ib2w6ICfQlNC40L0uJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBSVUI6IHtcbiAgICBzeW1ib2w6ICcg0YDRg9CxLicsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAwLFxuICB9LFxuICBSVVA6IHtcbiAgICBzeW1ib2w6ICdScCAnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDAsXG4gIH0sXG4gIFJXRjoge1xuICAgIHN5bWJvbDogJ1JXRicsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAwLFxuICB9LFxuICBTQVI6IHtcbiAgICBzeW1ib2w6ICfvt7wnLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgU0JEOiB7XG4gICAgc3ltYm9sOiAnJCcsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgU0NSOiB7XG4gICAgc3ltYm9sOiAn4oKoJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBTREc6IHtcbiAgICBzeW1ib2w6ICdTREcnLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgU0VLOiB7XG4gICAgc3ltYm9sOiAnIGtyJyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIFNHRDoge1xuICAgIHN5bWJvbDogJ1MkICcsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgU0hQOiB7XG4gICAgc3ltYm9sOiAnwqMnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIFNMTDoge1xuICAgIHN5bWJvbDogJ1NMTCcsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBTT1M6IHtcbiAgICBzeW1ib2w6ICdTJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBTUkQ6IHtcbiAgICBzeW1ib2w6ICckJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBTU1A6IHtcbiAgICBzeW1ib2w6ICdTU1AnLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgU1REOiB7XG4gICAgc3ltYm9sOiAnU1REJyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIFNZUDoge1xuICAgIHN5bWJvbDogJ8KjJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBTWkw6IHtcbiAgICBzeW1ib2w6ICdTWkwnLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgVEhCOiB7XG4gICAgc3ltYm9sOiAn4Li/JyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBUSlM6IHtcbiAgICBzeW1ib2w6ICdUSlMnLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgVE1UOiB7XG4gICAgc3ltYm9sOiAnVE1UJyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIFRORDoge1xuICAgIHN5bWJvbDogJy7Yry7YqicsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAzLFxuICB9LFxuICBUT1A6IHtcbiAgICBzeW1ib2w6ICdUT1AnLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgVFJZOiB7XG4gICAgc3ltYm9sOiAnIFRMJyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIFRURDoge1xuICAgIHN5bWJvbDogJ1RUJCcsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgVFdEOiB7XG4gICAgc3ltYm9sOiAnTlQkJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAwLFxuICB9LFxuICBUWlM6IHtcbiAgICBzeW1ib2w6ICdUU2gnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDAsXG4gIH0sXG4gIFVBSDoge1xuICAgIHN5bWJvbDogJ+KCtCcsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgVUdYOiB7XG4gICAgc3ltYm9sOiAnVVNoJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAwLFxuICB9LFxuICBVU0Q6IHtcbiAgICBzeW1ib2w6ICckJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBVWVU6IHtcbiAgICBzeW1ib2w6ICckVScsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMCxcbiAgfSxcbiAgVVpTOiB7XG4gICAgc3ltYm9sOiAnc2/igJltJyxcbiAgICBhZnRlcjogZmFsc2UsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxuICBWRUY6IHtcbiAgICBzeW1ib2w6ICdCcycsXG4gICAgYWZ0ZXI6IGZhbHNlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgVk5EOiB7XG4gICAgc3ltYm9sOiAn4oKrJyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDAsXG4gIH0sXG4gIFZVVjoge1xuICAgIHN5bWJvbDogJ1ZVVicsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAwLFxuICB9LFxuICBXU1Q6IHtcbiAgICBzeW1ib2w6ICdXU1QnLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMixcbiAgfSxcbiAgWEFGOiB7XG4gICAgc3ltYm9sOiAnWEFGJyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDAsXG4gIH0sXG4gIFhDRDoge1xuICAgIHN5bWJvbDogJyQnLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIFhPRjoge1xuICAgIHN5bWJvbDogJ1hPRicsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAwLFxuICB9LFxuICBYUEY6IHtcbiAgICBzeW1ib2w6ICdYUEYnLFxuICAgIGFmdGVyOiB0cnVlLFxuICAgIHByZWNpc2lvbjogMCxcbiAgfSxcbiAgWUVSOiB7XG4gICAgc3ltYm9sOiAn77e8JyxcbiAgICBhZnRlcjogdHJ1ZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIFpBUjoge1xuICAgIHN5bWJvbDogJ1InLFxuICAgIGFmdGVyOiBmYWxzZSxcbiAgICBwcmVjaXNpb246IDIsXG4gIH0sXG4gIFpNVzoge1xuICAgIHN5bWJvbDogJ1pNVycsXG4gICAgYWZ0ZXI6IHRydWUsXG4gICAgcHJlY2lzaW9uOiAyLFxuICB9LFxufTtcblxubW9kdWxlLmV4cG9ydHMgPSBjdXJyZW5jaWVzO1xuIl19